import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import Button from 'components/Button';
function RelatedSkillContentButton(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var search = {
    term: name
  };
  var searchLocation = createLocation('/search', search);
  return /*#__PURE__*/React.createElement(Button, {
    "aria-label": t('content_type_content_related_to', {
      name: name
    }),
    size: size,
    as: Link,
    to: searchLocation
  }, t('actions_search_related_content'));
}
export default RelatedSkillContentButton;